export default __webpack_public_path__ + "static/media/information--bike-route--g2.97104997.png";